var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTailoredColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "585.82px",
    height: "393.05px",
    viewBox: "0 0 585.82 393.05",
    style: {
      enableBackground: "new 0 0 585.82 393.05"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#0C958F;stroke-miterlimit:10;}\r\n\t.st1{fill:none;stroke:#000000;stroke-width:0.8;stroke-miterlimit:10;}\r\n\t.st2{fill:none;stroke:#3376B7;stroke-miterlimit:10;}\r\n\t.st3{fill:none;stroke:#F0D784;stroke-miterlimit:10;}\r\n\t.st4{fill:none;stroke:#000000;stroke-miterlimit:10;}\r\n\t.st5{fill:none;stroke:#000000;stroke-width:3;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st6{fill:none;stroke:#000000;stroke-width:4;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st7{fill:none;stroke:#000000;stroke-width:5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st8{fill:none;stroke:#F63137;stroke-miterlimit:10;}\r\n\t.st9{fill:none;stroke:#000000;stroke-width:8;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st10{fill:#F63137;stroke:#F63137;stroke-width:10;stroke-miterlimit:10;}\r\n\t.st11{fill:none;stroke:#F63137;stroke-width:9;stroke-miterlimit:10;}\r\n\t.st12{fill:#F63137;stroke:#FFFFFF;stroke-width:10;stroke-miterlimit:10;}\r\n\t.st13{fill:none;stroke:#0C958F;stroke-width:13;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st14{fill:none;stroke:#0C958F;stroke-width:13;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st15{fill:none;stroke:#0C958F;stroke-width:13;stroke-miterlimit:10;}\r\n\t.st16{fill:none;stroke:#3376B7;stroke-width:13;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st16",
    cx: 199.37,
    cy: 122.62,
    rx: 65,
    ry: 39.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st16",
    cx: 196.87,
    cy: 125.62,
    rx: 99.5,
    ry: 68.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st16",
    cx: 198.37,
    cy: 130.62,
    rx: 137,
    ry: 105.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M61.47,134.42c0.3,34.9-2.9,72.8-2.6,107.7c0.1,14.7,0.3,29.6,4.1,43.8c9.8,36.8,46.7,59.4,88.5,67 c32.7,5.9,86.8,6.7,86.8,6.7l47.9-1.2l123.3-1.6l57.8-2.5c0,0,53.7-1.1,87.4-0.8c0.2,0,0.3,0,0.5,0c0.3,0,0.6,0,1,0h0.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M550.57,359.62c0.1-41.2-0.8-86.7-1.6-127.9c-31,0-93.7-0.3-93.7-0.3l-29.8,0.7l-36.8-0.7l-30.6,0.2 l-37.8,1.7c0,0-74,1-97.6,1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M334.27,117.02c1.8,23.2,6,85.2,3.7,111"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M135.17,259.52c-0.3,30.5-1.3,60.4-1.6,89.4c0-0.2-0.5-0.8-0.5-1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M94.17,277.92c0.1,18-0.7,35.5-0.6,52.6c0-0.1-0.5-0.5-0.5-0.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M177.17,299.92c0.1,18-0.7,35.5-0.6,52.6c0-0.1-0.5-0.5-0.5-0.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M219.87,274.72c-0.5,28-1.8,55.4-2.3,82c0-0.1-0.5-0.8-0.4-0.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M258.17,303.82c0.1,18.1-0.7,35.7-0.6,52.9c0-0.1-0.5-0.5-0.5-0.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M304.67,274.72c-0.4,27.3-1.7,54.1-2.2,80c0-0.1-0.5-0.8-0.4-0.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M346.17,301.72c0.1,18.1-0.7,35.8-0.6,53c0-0.1-0.5-0.5-0.5-0.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M387.87,274.82c-0.4,26.6-1.6,52.6-2,77.9c0-0.1-0.5-0.7-0.5-0.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M428.27,304.42c0.1,16.9-0.6,33.3-0.4,49.3c0-0.1-0.5-0.5-0.5-0.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M471.77,274.92c-0.4,25.9-1.6,51.3-1.9,76c0-0.1-0.5-0.7-0.5-0.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M512.57,304.52c0.1,16.8-0.5,33.3-0.4,49.2c0-0.1-0.5-0.5-0.5-0.6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTailoredColor);
export default __webpack_public_path__ + "static/media/tailoredColor.afae38a3f5ec8897e4273289e3347ee7.svg";
export { ForwardRef as ReactComponent };